import { updateGeo } from 'shared/slices/jsonQuery';
import { TThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { removePolygonFromJsonQuery } from 'shared/utils/jsonQuery';
import { applyFilters } from 'shared/thunks/filters';
import { updateTags } from 'shared/thunks/tags';

export const removePolygon = (): TThunkAction => (dispatch, getState) => {
  const state = getState();
  const jsonQuery = selectJsonQuery(state);

  const nextGeo = removePolygonFromJsonQuery(jsonQuery);

  dispatch(updateGeo(nextGeo));
  dispatch(updateTags());
  dispatch(applyFilters());
};
